export const APPROVALS_ORIGINALSTATE = {
  AWAITING_APPROVAL: "AWAITING APPROVAL",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  NO_LONGER_REQUIRED: "NO LONGER REQUIRED",
};

export const REQUEST_STATE = {
  REJECTED: "Rejected",
  OPEN: "Open",
  CLOSED: "Closed",
};

export const NOT_APPLICABLE = 'N/A';

export const YES = 'yes';

export const AWAITING_APPROVAL = "awaiting_approval";

export const FONT_DEFAULT = 'Open Sans';

export const DEVICE_STATUS = {
  ELIGIBLE_FOR_REFRESH: 'ELIGIBLE_FOR_REFRESH',
  INACTIVE: 'INACTIVE',
  IN_USE: 'IN USE',
};

export const ESSPRESSIVE_INTEGRATION ='ESSPRESSIVEINTEGRATION';